import apiName from "./constants";

const authServices = "https://d2e3tc5eudzwx6.cloudfront.net/api/v1/";
const attendanceService = "https://d13qynr95pr2un.cloudfront.net/api/v1/";
const userServices = "https://d2ev8m6riphn46.cloudfront.net/api/v1/";
const googleAPI = "https://maps.googleapis.com/maps/api/place/autocomplete/json?input=";

// const authServices = "http://localhost:3000/api/v1/";
// const attendanceService = "http://localhost:3001/api/v1/";
// const userServices = "http://localhost:3002/api/v1/";

const config = {
  authServices,
  userServices,
  attendanceService,
  googleAPI,
  apiName,
};
export default config;